export default __webpack_public_path__ + "static/media/location--7.e54a1959.jpg";